import _ from 'lodash'
import { createSelector } from 'reselect'
import { Store } from '../types'

export const loadingSelector = (store: Store) => store.loading
export const anyLoadingSelector = createSelector(loadingSelector, loading => Object.values(loading).some(v => v))

/** A single loading flag, so the component re-renders only when that flag changes. */
export const loadingKeySelector = (key: string) => (store: Store) => !!store.loading[key]

/** Loading flags whose key starts with the prefix. Use with shallowEqual to skip unrelated loading changes. */
export const loadingByPrefixSelector = (prefix: string) => (store: Store) =>
  _.pickBy(store.loading, (_value, key) => key.startsWith(prefix))
